import { render, staticRenderFns } from "./ApplicantMerchantContractPage.vue?vue&type=template&id=be02912e&scoped=true"
import script from "./ApplicantMerchantContractPage.vue?vue&type=script&lang=js"
export * from "./ApplicantMerchantContractPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be02912e",
  null
  
)

export default component.exports